module.exports = __webpack_public_path__ + "img/collection-diamondJewelryExclusive.deae1c1.jpg";